import { getErrorMessage } from '../../../lib/utils';

export default function (app) {
  return {
    state: {
      personalityTraits: [],
    },
    getters: {
      resolvePersonalityTrait: state => (identifier, codeOnly) => {
        const [personalityTraitId, personalityTraitIndexString,] = String(identifier).split(':');

        const personalityTraitIndexInt = parseInt(personalityTraitIndexString);
        const personalityTraitIndex = (!personalityTraitIndexString || isNaN(personalityTraitIndexInt)) ? null : personalityTraitIndexInt;

        const personalityTrait = state.personalityTraits.filter(({ id, }) => id === personalityTraitId).pop();

        let result;
        if (personalityTrait) {
          const index = personalityTraitIndex !== null ? `:${personalityTraitIndex + 1}` : '';
          const code = `${personalityTrait.code}${index}`;
          result = {
            ...personalityTrait,
            descriptor: codeOnly ? code : `(${code}) ${personalityTrait.descriptor}`,
            shortDescriptor: personalityTrait.descriptor,
            index: personalityTraitIndex,
          };
        } else {
          result = {
            descriptor: personalityTraitId,
          };
        }

        return result;
      },
    },
    actions: {
      async listPersonalityTraits({ commit, state, dispatch, }, params = {}) {
        commit('setError', {});
        const actionId = await dispatch('addPendingAction');

        if (state.personalityTraits.length > 0) {
          commit('removePendingAction', actionId);
          return;
        }

        try {
          const result = await app.service('personality-traits').find(params);
          commit('setPersonalityTraits', result.data);

          return result;
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },
    },
    mutations: {
      setPersonalityTraits: (state, personalityTraits) => state.personalityTraits = personalityTraits,
    },
  };
}
